import { ThemeProvider } from '@mui/material';
import { MuiTheme } from '../components/Theme/theme';
import { ReactNode } from 'react';
import { DialogProvider } from '../components/provider/MuiDialog';
import { CustomSnackbarProvider } from '../components/Notistack/Notistack';

type ProvidersProps = {
  children: ReactNode;
};

const Providers: React.FC<ProvidersProps> = (props) => {
  const { children } = props;
  return (
    <ThemeProvider theme={MuiTheme}>
      <CustomSnackbarProvider>
        <DialogProvider>{children}</DialogProvider>
      </CustomSnackbarProvider>
    </ThemeProvider>
  );
};

export default Providers;
